// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3MHta","header":"MessagesList_header__3Ak-p","chat":"MessagesList_chat__2yUvL"};